<template>
  <svg aria-hidden="true" class="svg-symbol">
    <use :href="symbolId" fill="currentColor" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { SymbolName } from "@core/ui/svg-icons/symbols/SymbolName";

const props = defineProps<{
  name: SymbolName;
}>();

const symbolId = computed(() => `#svg-symbols-${props.name}`);
</script>

<style>
.svg-symbol {
  max-height: 1em;
  max-width: 1em;

  display: inline-block;
  vertical-align: middle;
  overflow: visible;
}
</style>
